import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpClient.service';
import { Observable } from 'rxjs';
import { PaginationType } from '../../interfaces/pagination/pagination-type';
import { dashboardApi } from '../../constants/dashboard-api';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  constructor(private httpClientService: HttpClientService) {}

  getDashboardCounts(): Observable<any> {
      return this.httpClientService.get(`${dashboardApi.getDashboardCounts}`);
  }

  getPowerBiToken(): Observable<any> {
    return this.httpClientService.get(`${dashboardApi.getPowerBi}`);
  }

  getPowerBiTokenV2(): Observable<any> {
    return this.httpClientService.get(`${dashboardApi.getPowerBi2}`);
  }

updateService(payload, id:any): Observable<any> {
  return this.httpClientService.put(`${dashboardApi.getUpdateService}?Id=${id}`, payload);
}

}
